import React from "react";

// Ícono del Asistente IA (robot). NO usa la foto del doctor; es un SVG inline,
// así que no depende de ningún archivo en /public.
export default function AgentIcon({ className = "w-8 h-8" }) {
  return (
    <span
      className={`${className} inline-flex items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 text-white shadow-sm`}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        className="w-2/3 h-2/3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* antena */}
        <circle cx="12" cy="3" r="1.2" fill="currentColor" stroke="none" />
        <path d="M12 4.2V7" />
        {/* cabeza */}
        <rect x="4.5" y="7" width="15" height="11" rx="3" />
        {/* ojos */}
        <circle cx="9.2" cy="12.5" r="1.4" fill="currentColor" stroke="none" />
        <circle cx="14.8" cy="12.5" r="1.4" fill="currentColor" stroke="none" />
        {/* orejas */}
        <path d="M2.5 11.5v3M21.5 11.5v3" />
      </svg>
    </span>
  );
}
